import { faHashtag } from "@fortawesome/pro-regular-svg-icons";
import { Drawer, Grid, Icon } from "@intility/bifrost-react";
import { useQueries } from "@tanstack/react-query";
import { clientQuery, useClients } from "../api/clients";
import { ClientTypeBadge } from "./ClientTypeBadge";

// Every client that carries `tag`. Tags live on the full client record and the
// list endpoint has no tag filter, so the records are fetched one by one while
// the drawer is open (they share the cache with `useClient`).
export function ClientsByTagDrawer({
  tag,
  onClose,
}: {
  tag: string | null;
  onClose: () => void;
}) {
  const open = tag !== null;
  const { data: clients = [] } = useClients();
  const details = useQueries({
    queries: clients.map((c) => ({ ...clientQuery(c.id), enabled: open })),
  });

  const loading = open && details.some((d) => d.isPending);
  const matches = details.flatMap((d) =>
    d.data && tag !== null && d.data.tags.includes(tag) ? [d.data] : [],
  );

  return (
    <Drawer
      isOpen={open}
      onRequestClose={onClose}
      header={
        <>
          Client with <Icon icon={faHashtag} />
          {tag}
        </>
      }
    >
      <Grid gap={12} style={{ marginTop: 24 }}>
        {matches.map((c) => (
          <div
            key={c.id}
            style={{
              display: "flex",
              gap: 12,
              alignItems: "center",
              padding: 8,
              border: "1px solid var(--bfc-base-dimmed)",
              borderRadius: 8,
            }}
          >
            <ClientTypeBadge appType={c.appType} />
            <div style={{ minWidth: 0 }}>
              <div className="bf-strong">{c.name}</div>
              <div className="bf-p bfc-base-2" style={{ margin: 0 }}>
                {c.clientId}
              </div>
            </div>
          </div>
        ))}
        {loading && <Icon.Spinner size={24} />}
        {!loading && matches.length === 0 && (
          <p className="bf-p bfc-base-2" style={{ margin: 0 }}>
            No clients have this tag.
          </p>
        )}
      </Grid>
    </Drawer>
  );
}
